/* eslint-disable no-unused-vars */
/* eslint-disable max-lines */
import React, {
 useState, useEffect, useCallback, useContext
} from 'react';
import {
 schemaService
} from 'shared/api/services/BEXO';
import {
 useParams
} from 'react-router-dom';
import {
 useRouting
} from '../RoutingContext';
import {
 Context
} from 'shared/context/GlobalState';
import {
 Card, CardContent
} from 'shared/components/ui/card';
import {
 FieldsHeader
} from './FieldsHeader';
import {
 FieldsTable
} from './FieldsTable';
import AlertModal from 'shared/components/Alertmodal';
import {
 DEFAULT_NEW_FIELD
} from './constants';
import {
 useRecordsData
} from '../table-records/RecordsData';
import {
 Field
} from './types/builderFields.types';
interface TableFieldsProps {
  tableId: string;
}

export const TableFields: React.FC<TableFieldsProps> = ({
 tableId
}) => {
  const [fields, setFields] = useState<Field[]>([]);
  const [originalFields, setOriginalFields] = useState<Field[]>([]);
  const [editingFields, setEditingFields] = useState<string[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [filterColumn, setFilterColumn] = useState<string | null>(null);
  const [filterValue, setFilterValue] = useState<string>('');
  const [sortColumn] = useState<string | null>(null);
  const [sortDirection] = useState<'asc' | 'desc'>('asc');
  // const [hiddenColumns, setHiddenColumns] = useState<string[]>([]);
  const [selectedFields, setSelectedFields] = useState<Field[]>([]);
  const [tableColumns, setTableColumns] = useState<{ value: string; label: string }[]>([]);

  const [delModal, setDelModal] = useState<boolean>(false);
  const [delBtn, setDelBtn] = useState<boolean>(false);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [nameError, setNameError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const {
 addNewNotifcation
} = useContext(Context);
  const {
 tables
} = useRouting();

  const {
 appId, oragID
} = useParams();
  const tableName = tables.find((table) => table.id === tableId)?.name || null;

  const hasNewFields = fields.some((field) => field.isNew);
  const getNewFields = useCallback(
    () =>
      fields
        .filter((field) => field.isNew)
        .map(({
 ...rest
}) => rest),
    [fields]
  );
  const {
 fetchAllRecords
} = useRecordsData('UserRole');
  const getModifiedFields = useCallback(() => {
    return fields
      .filter((field) => {
        if (field.isNew) return false;
        const originalField = originalFields.find((f) => f.id === field.id);
        if (!originalField) return false;
        return JSON.stringify(field) !== JSON.stringify(originalField);
      })
      .map((field) => {
        const {
 id, ...cleanField
} = field;
        const originalField = originalFields.find((f) => f.id === id);
        if (originalField?.columnName !== field.columnName) {
          return {
            ...cleanField,
            previousColumnName: originalField.columnName,
          };
        }
        const {
  ...fieldWithoutPrevious
} = cleanField;
        return fieldWithoutPrevious;
      });
  }, [fields, originalFields]);

  const hasModifiedFields = getModifiedFields().length > 0;
  // const isEditingMode = hasModifiedFields && !hasNewFields;
  const isAddingMode = hasNewFields && !hasModifiedFields;

  const processedFields = fields
    .filter((field) => {
      if (searchTerm) {
        const searchLower = searchTerm.toLowerCase();
        return (
          field?.columnName?.toLowerCase().includes(searchLower) ||
          field?.description?.toLowerCase().includes(searchLower) ||
          field?.dataType?.toLowerCase().includes(searchLower)
        );
      }
      return true;
    })
    .filter((field) => {
      if (filterColumn && filterValue) {
        const value = field?.[filterColumn];
        if (Array.isArray(value)) {
          return value.some((v) => String(v || '').toLowerCase().includes(filterValue.toLowerCase()));
        }
        return String(value || '').toLowerCase().includes(filterValue.toLowerCase());
      }
      return true;
    })
    .sort((a, b) => {
      if (sortColumn) {
        const aValue = a?.[sortColumn];
        const bValue = b?.[sortColumn];

        if (Array.isArray(aValue) && Array.isArray(bValue)) {
          const aStr = aValue.join(',');
          const bStr = bValue.join(',');
          return sortDirection === 'asc' ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr);
        }

        return sortDirection === 'asc'
          ? String(aValue || '').localeCompare(String(bValue || ''))
          : String(bValue || '').localeCompare(String(aValue || ''));
      }
      return 0;
    });

  const handleAddField = useCallback(() => {
    const newId = `new-${Date.now()}`;
    const newField = {
      ...DEFAULT_NEW_FIELD,
      id: newId,
      columnName: `New Field ${fields.filter((f) => f.isNew).length + 1}`,
      isNew: true,
    };
    setFields((prev) => [newField, ...prev]);
    setEditingFields((prev) => [newId, ...prev]);
  }, [fields]);

  const handleRetrieveFields = useCallback(
    async (tableName) => {
      if (!tableName) return;

      setIsLoading(true);
      try {
        const result = await fetchAllRecords();
        const resRecord = result.records;
        const accessRoles = resRecord.map(({
 recordId, roleName
}) => ({
          value: recordId,
          label: roleName,
        }));
        const res = await schemaService.retrieveSchemas(tableName, appId, oragID);
        const retrievedFields = res?.data?.schemas?.[0]?.columns || [];
        retrievedFields.forEach((field) => {
          if (field.fieldsAccessBy && field.fieldsAccessBy.length > 0) {
            field.fieldsAccessBy = field.fieldsAccessBy
              .map((id) => {
                const role = accessRoles.find((role) => role.value === id);
                return role ? role.label : null;
              })
              .filter((label) => label !== null); // Remove null values
          }
        });
        const retrievedFieldsWithId = retrievedFields.map((field, index) => {
          const {
  ...cleanField
} = field;

          return {
            ...cleanField,
            id: `${index + 1}`,
            previousColumnName: '',
            ...(cleanField.dataType === 'enum' ? {
 options: cleanField.values || []
} : {}),
          };
        });

        setFields(retrievedFieldsWithId);
        setOriginalFields(retrievedFieldsWithId);
        setEditingFields([]);
      } catch (e) {
        console.error('Error retrieving fields:', e);
        setFields([]);
        setOriginalFields([]);
      } finally {
        setIsLoading(false);
      }
    },
    [appId, oragID]
  );

  const handleTableSelect = useCallback(
    async (selectedTable) => {
      if (!selectedTable) {
        setTableColumns([]);
        return;
      }
      try {
        const res = await schemaService.retrieveSchemas(selectedTable, appId, oragID);
        const columns = res?.data?.schemas?.[0]?.columns || [];
        setTableColumns(
          columns.map((col) => ({
            value: col.columnName,
            label: col.columnName,
          }))
        );
      } catch (e) {
        console.error('Error fetching table columns:', e);
        setTableColumns([]);
      }
    },
    [appId, oragID]
  );

  const handleRefresh = async () => {
    setSearchTerm('');
    setFilterColumn(null);
    setFilterValue('');
    if (tableName) {
      await handleRetrieveFields(tableName);
    }
  };

  useEffect(() => {
    handleRetrieveFields(tableName);
  }, [handleRetrieveFields, tableId, tableName]);

  const handleSelectField = useCallback(
    (fieldId) => {
      setSelectedFields((prev) => {
        const alreadySelected = prev.some((field) => field.id === fieldId);
        if (alreadySelected) {
          return prev.filter((field) => field.id !== fieldId);
        }
        const fieldObject = processedFields.find((field) => field.id === fieldId);
        if (fieldObject) {
          return [...prev, fieldObject];
        }
        return prev;
      });
    },
    [processedFields]
  );

  // const handleHeaderSelectAll = useCallback(
  //   (checked) => {
  //     if (checked) {
  //       setSelectedFields(processedFields);
  //     } else {
  //       setSelectedFields([]);
  //     }
  //   },
  //   [processedFields]
  // );

  const handleDeleteField = async (fieldsToDelete) => {
    const allNew = fieldsToDelete.every((f) => f.isNew);

    if (allNew) {
      const remaining = fields.filter((f) => !fieldsToDelete.some((toDelete) => toDelete.id === f.id));
      setFields(remaining);
      setSelectedFields([]);
      setEditingFields((prev) => prev.filter((id) => !fieldsToDelete.some((f) => f.id === id)));
      addNewNotifcation('Draft Field deleted successfully', 'success');
    } else {
      setSelectedFields(fieldsToDelete);
      setDelModal(true);
    }
  };

  const handleDeleteExistingFields = async (fieldsToDelete) => {
    setIsDeleting(true);
    setDelBtn(true);
    try {
      const payload = {
        schemas: [
          {
            tableName: tableName,
            columns: fieldsToDelete.map((field) => ({
              columnName: field.columnName,
            })),
          },
        ],
      };

      await schemaService.deleteSchemas(payload, oragID, appId);
      await handleRetrieveFields(tableName);
      setSelectedFields([]);
      setDelModal(false);
      addNewNotifcation('Fields deleted successfully', 'success');
    } catch (e) {
      console.error('Error deleting fields:', e);
      addNewNotifcation('Error deleting fields', 'danger');
    } finally {
      setIsDeleting(false);
      setDelBtn(false);
    }
  };

  const validateRequiredFields = (field) => {
    const missing = [];
    if (!field.columnName?.trim()) missing.push('Column Name');
    if (!field.description?.trim()) missing.push('Description');
    if (!field.dataType?.trim()) missing.push('Data Type');
    if (!Array.isArray(field.fieldsAccessBy) || field.fieldsAccessBy.length === 0) missing.push('Field Access');
    if (field.dataType === 'connection') {
      if (!field.references?.table?.trim()) missing.push('Referenced Table');
      if (!field.references?.column?.trim()) missing.push('Referenced Column');
    }
    return missing;
  };

  const cleanFieldForPayload = (field) => {
    const {
  ...rest
} = field;

    let formattedColumnName = field.columnName.trim();

    let words = formattedColumnName.split(/\s+/);

    formattedColumnName = words
      .map((word, index) => {
        if (word.toUpperCase() === word) {
          return word;
        }
        if (index === 0) {
          return word.toLowerCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join('');

    return {
      ...rest,
      columnName: formattedColumnName,
    };
  };

  const saveSchema = async () => {
    setIsSaving(true);

    const modifiedFields = fields.filter(
      (field) =>
        !field.isNew &&
        originalFields.some((of) => of.id === field.id) &&
        JSON.stringify(originalFields.find((of) => of.id === field.id)) !== JSON.stringify(field)
    );

    const newFieldsToAdd = fields.filter((field) => field.isNew);

    const invalidModified = modifiedFields.filter((field) => validateRequiredFields(field).length > 0);
    const invalidNew = newFieldsToAdd.filter((field) => validateRequiredFields(field).length > 0);

    if (invalidModified.length > 0 || invalidNew.length > 0) {
      const sampleMissing = validateRequiredFields(invalidModified[0] || invalidNew[0]);
      addNewNotifcation(`Please fill out all required fields: ${sampleMissing.join(', ')}`, 'danger');
      setIsSaving(false);
      return;
    }

    const nameConflicts: string[] = [];
    const existingNames = new Set(
      originalFields
        .filter((f) => !modifiedFields.some((mf) => mf.id === f.id))
        .map((f) => f.columnName.toLowerCase())
    );

    modifiedFields.forEach((field) => {
      if (existingNames.has(field.columnName.toLowerCase())) {
        nameConflicts.push(field.columnName);
      }
      existingNames.add(field.columnName.toLowerCase());
    });

    newFieldsToAdd.forEach((field) => {
      if (existingNames.has(field.columnName.toLowerCase())) {
        nameConflicts.push(field.columnName);
      }
      existingNames.add(field.columnName.toLowerCase());
    });

    if (nameConflicts.length > 0) {
      addNewNotifcation(`Field name already exists: ${nameConflicts.join(', ')}`, 'danger');
      setIsSaving(false);
      return;
    }

    try {
      if (modifiedFields.length > 0) {
        const modifyPayload = {
          schemas: [
            {
              tableName: tableName,
              columns: modifiedFields.map((field) => {
                const cleanField = cleanFieldForPayload(field);
                if (!cleanField.previousColumnName) {
                  const originalField = originalFields.find((f) => f.id === field.id);
                  if (originalField && originalField.columnName !== field.columnName) {
                    cleanField.previousColumnName = originalField.columnName;
                  }
                }
                return cleanField;
              }),
            },
          ],
        };
        await schemaService.modifySchemas(modifyPayload, appId, oragID);
      }

      if (newFieldsToAdd.length > 0) {
        const addPayload = {
          schemas: [
            {
              tableName: tableName,
              columns: newFieldsToAdd.map((field) => cleanFieldForPayload(field)),
            },
          ],
        };
        await schemaService.createSchemas(oragID, appId, addPayload);
      }

      await handleRetrieveFields(tableName);
      if (modifiedFields.length > 0 && newFieldsToAdd.length === 0) {
        addNewNotifcation('Fields updated successfully', 'success');
      } else if (newFieldsToAdd.length > 0 && modifiedFields.length === 0) {
        addNewNotifcation('New fields added successfully', 'success');
      } else {
        addNewNotifcation('Fields saved successfully', 'success');
      }
    } catch (e) {
      console.error('Error saving schema:', e);
      addNewNotifcation('Error saving schema', 'danger');
    } finally {
      setIsSaving(false);
      setEditingFields([]);
    }
  };

  const handleFieldNameChange = (fieldId: string, newName: string) => {
    setNameError(null);
    const currentField = fields.find((f) => f.id === fieldId);
    const isNewField = currentField?.isNew;
    const originalName = originalFields.find((f) => f.id === fieldId)?.columnName;
    const conflictFields = fields.filter(
      (f) => f.id !== fieldId && f.columnName?.toLowerCase() === newName?.toLowerCase()
    );

    if (conflictFields.length > 0) {
      setNameError(`Field name "${newName}" already exists`);
    }

    setFields((prev) =>
      prev.map((f) => {
        if (f.id === fieldId) {
          return {
            ...f,
            columnName: newName,
            isModified: !isNewField && originalName !== newName,
          };
        }
        return f;
      })
    );
  };

  const toggleEditingField = (fieldId: string) => {
    setEditingFields((prev) => {
      if (prev.includes(fieldId)) {
        return prev.filter((id) => id !== fieldId);
      }
      return [...prev, fieldId];
    });
  };

  return (
      <Card className="flex flex-col border shadow-sm h-50 w-full">
          <AlertModal
        loading={delBtn}
        openModal={delModal}
        setopenModal={setDelModal}
        title={`Are you sure you want to delete ${selectedFields.map((f) => f.columnName).join(', ')}?`}
        onDelete={async () => {
          if (selectedFields) {
            await handleDeleteExistingFields(selectedFields);
          }
          setDelModal(false);
        }}
      />
          <CardContent className="p-0 h-full w-full flex flex-col">
              <div className="flex flex-1 flex-col overflow-hidden h-full w-full">
                  <FieldsHeader
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            filterColumn={filterColumn}
            setFilterColumn={setFilterColumn}
            filterValue={filterValue}
            setFilterValue={setFilterValue}
            // sortColumn={sortColumn}
            // setSortColumn={setSortColumn}
            // sortDirection={sortDirection}
            // setSortDirection={setSortDirection}
            // hiddenColumns={hiddenColumns}
            // setHiddenColumns={setHiddenColumns}
            selectedFields={selectedFields}
            // handleDeleteFields={handleDeleteField}
            isDeleting={isDeleting}
            //  modifiedFieldsCount={getModifiedFields().length}
            newFieldsCount={getNewFields().length}
                       saveSchema={saveSchema}
            isSaving={isSaving}
            // handleHeaderSelectAll={handleHeaderSelectAll}
            // isEditingMode={isEditingMode}
            isAddingMode={isAddingMode}
            setFieldsToDelete={setSelectedFields}
            setDelModal={setDelModal}
            onRefresh={handleRefresh}
            handleAddField={handleAddField}
          />
                  <div className="flex-1 overflow-hidden">
                      <div
              style={{
                maxHeight: 'calc(100vh - 400px)',
                overflowX: 'auto',
              }}
            >
                          <FieldsTable
                processedFields={processedFields}
                // hiddenColumns={hiddenColumns}
                selectedFields={selectedFields}
                handleSelectField={handleSelectField}
                editingFields={editingFields}
                // setEditingFields={setEditingFields}
                toggleEditingField={toggleEditingField}
                handleSaveField={saveSchema}
                handleDeleteField={handleDeleteField}
                handleFieldNameChange={handleFieldNameChange}
                nameError={nameError}
                setFields={setFields}
                tableColumns={tableColumns}
                handleTableSelect={handleTableSelect}
                tables={tables}
                isLoading={isLoading}
                hasNewFields={hasNewFields}
                isSaving={isSaving}
              />
                      </div>
                  </div>
              </div>
          </CardContent>
      </Card>
  );
};
